<template>
  <v-responsive :aspect-ratio="1" class="w-100 d-flex">
    <v-card
      outlined
      :elevation="$vuetify.theme.dark ? 2 : 2"
      class="border pt-2 pb-3 px-3 d-flex flex-column fill-height w-100 kpi-card"
      :color="$vuetify.theme.dark ? '#424242' : '#FFFFFF'"
    >
      <v-row no-gutters class="flex-grow-0" align="center">
        <v-icon v-if="icon" class="mr-2" size="22">
          {{ icon }}
        </v-icon>
        <span class="text-subtitle-1 font-weight-medium">
          {{ kpiTitle }}
        </span>
      </v-row>

      <v-row no-gutters class="flex-grow-1" align="center" justify="center">
        <v-col cols="12" class="pa-0 text-center">
          <span class="text-h3 font-weight-bold" v-if="kpiValue !== null && kpiValue !== undefined && kpiValue !== ''">
            {{ formattedValue }}
          </span>
          <span class="text-h3 font-weight-bold" v-else>-</span>

          <span v-if="kpiUnit === '%'" class="ml-1 text-h4 font-weight-bold">%</span>
          <span v-else-if="kpiUnit" class="ml-1 text-subtitle-1">{{ kpiUnit }}</span>
        </v-col>
      </v-row>
    </v-card>
  </v-responsive>
</template>

<script>
export default {
  name: "ValueKpi",
  props: {
    kpiTitle: {
      type: String,
      required: true
    },
    kpiValue: {
      type: [Number, String],
      default: null
    },
    kpiUnit: {
      type: String,
      default: ""
    },
    kpiDescription: {
      type: String,
      default: ""
    },
    decimals: {
      type: Number,
      default: 1
    },
    icon: {
      type: String,
      default: ""
    },
    minHeight: {
      type: [Number, String],
      default: 170
    },
    square: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedValue() {
      if (typeof this.kpiValue === "number") {
        return this.kpiValue.toFixed(this.decimals);
      }
      return this.kpiValue;
    }
  }
};
</script>
